<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { workbookTabKey } from '@/lib/workbookRoute';

defineProps<{ sessionKey: string }>();
const route = useRoute();
const tabKey = computed(() => workbookTabKey(route));
</script>

<template>
  <RouterView v-slot="{ Component }">
    <!-- Все посещённые вкладки книги сохраняют DOM, выделение и измерения.
         Смена сессии освобождает одновременно видимую и скрытые таблицы. -->
    <KeepAlive :key="sessionKey">
      <component :is="Component" v-if="tabKey" :key="tabKey" />
    </KeepAlive>
    <Transition name="page" mode="out-in">
      <component :is="Component" v-if="!tabKey" :key="`${sessionKey}:${String(route.name)}`" />
    </Transition>
  </RouterView>
</template>
